<template>
  <div class="row">
    <div class="col_12">
      <div class="card no_border">
        <div class="card-header">
          <div class="card-title">상담내역</div>
        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row">
            <div class="col_2">
                <div class="form-group ">
                    <label>문의종류</label>
                    <div class="d_flex_start">
                        <div class="dropdown custom_dropdown mr_10">
                            <button class="btn">
                                <span>{{ filter2.inquiry_type }}</span>
                            </button>
                            <div class="dropdown_menu">
                                <ul>
                                    <li><a role="button" @click="changeInquiryTypeFilter('all')">{{ $t('common.all') }}</a></li>
                                    <li v-for="inquiry_type in inquiryTypes" :key="'inquiry_type '+inquiry_type.id">
                                        <a role="button" @click="changeInquiryTypeFilter(inquiry_type)">{{ inquiry_type.name }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col_2">
              <div class="form-group ">
                  <label></label>
                  <div class="d_flex_start">
                    <div class="dropdown custom_dropdown mr_10">
                        <button class="btn">
                          <span>{{ filter2.answer_complete }}</span>
                        </button>
                        <div class="dropdown_menu">
                          <ul>
                            <li @click="changeStatusFilter('all')"><a role="button">{{ $t('common.all') }}</a></li>
                            <li @click="changeStatusFilter('waiting')"><a role="button">답변대기</a></li>
                            <li @click="changeStatusFilter('completed')"><a role="button">답변완료</a></li>
                          </ul>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="col_8">
              <div class="form-group ">
                <label></label>
                <div class="d_flex_end">
                  <div class="form_row_inline ml_10">
                    <input type="text" class="form_global" :placeholder="$t('common.search')" v-model="queryParams.search">
                  </div>
                  <div class="form_row_inline ml_10">
                    <div class="btn btn_common_type_2 width_150p" @click="queryParams.page = 1 ; searchQuery()">{{ $t('common.search') }}</div>
                  </div>
                  <div class="form_row_inline ml_10">
                    <div class="btn btn_common_type_2 width_150p" @click="resetAll()">{{ $t('common.reset') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col_12 ">
              <div class="separator pl_0 pr_0">
                <span></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col_12">
              <div class="d_flex_btwn pt_20 pb_20">
                <div class="d_flex_start col_2 pl_0">
                  <div class="dropdown custom_dropdown mr_10">
                      <button class="btn">
                          <span>{{ filter.per_page }}</span>
                      </button>
                      <div class="dropdown_menu">
                          <ul>
                            <li @click="changePerPageFilter(10)"><a role="button">10</a></li>
                            <li @click="changePerPageFilter(20)"><a role="button">20</a></li>
                            <li @click="changePerPageFilter(50)"><a role="button">50</a></li>
                            <li @click="changePerPageFilter(100)"><a role="button">100</a></li>
                            <li @click="changePerPageFilter(200)"><a role="button">200</a></li>
                          </ul>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <table-component 
            :columns="columns"
            :rows="consultations"
            :pagination="pagination"
            @sorting="sorting"
            :sortable="sortable"
            @pageChanged="pageChanged">
            <template #action="{ row }">
              <div class="d_flex_center table_action_btn">
                <button class="btn btn_blue ml_10" :title="$t('common.edit')" @click.prevent="openConsultationRequestModal(row)">
                  <img :src="`${baseUrl}assets/media/images/icon/8.png`" alt="">
                </button>
                <button class="btn btn_danger ml_10" :title="$t('common.delete')" @click.prevent="deleteRecord(row)">
                  <img :src="`${baseUrl}assets/media/images/icon/9.png`" alt="">
                </button>
              </div>
            </template>
          </table-component>
        </div>
      </div>
    </div>
    <ConsultationModal 
      v-if="showConsultationRequestModal"
      :showConsultationRequestModal="showConsultationRequestModal"
      :consultationData="consultationData"
      @closeModal="closeModal"
    />
    
  </div>
</template>

<script>
import TableComponent from "@/components/shared/TableComponent";
import ConsultationModal from "./ConsultationModal.vue";
export default {
  components: {TableComponent, ConsultationModal},
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE,
      inquiryTypes: [],
      consultations: [],
      filter: {
        inquiry_type: 'all',
        answer_complete: 'all',
        per_page: 20
      },
      filter2: {
        inquiry_type: this.$t('common.all'),
        answer_complete: this.$t('common.all'),
        per_page: 20
      },
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'parent.email,parent.name,student.student_id,student.name,inquiry_type.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      },
      pagination: null,
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: '학부모 아이디',
          field: "parent.email",
          sortable: false
        },
        {
          label: '학부모명',
          field: "parent.name",
          sortable: false
        },
        {
          label: '학생아이디',
          field: "student.student_id",
          sortable: false
        },
        {
          label: '학생명',
          field: "student.name",
          sortable: false
        },
        {
          label: '문의종류',
          field: "inquiry_type.name",
          sortable: false
        },
        {
          label: '상태',
          field: "formatted_answer_complete",
          sortable: false
        },
        {
          label: '수정/삭제',
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      showConsultationRequestModal: false,
      consultationData: ''
    }
  },
  watch: {
    $route(to, from) {
        if(to.name == from.name && !window._.isEqual(to, from)){
          this.setQueryData(this.getAllQueryParams())
          this.loadData()
        }
      },
  },
  created() {
    const query = this.getAllQueryParams()
    if(query.page){
      this.setQueryData(query)
    }
    this.axios.get('/inquiry-types?status=1').then((response) => this.inquiryTypes = response.data.data);
    this.loadData();
  },
  methods: {
    changeInquiryTypeFilter(inquiry_type) {
        if (inquiry_type == 'all') {
            this.filter.inquiry_type = ''
            this.filter2.inquiry_type = this.$t('common.all')
        } else {
            this.filter.inquiry_type = inquiry_type.id
            this.filter2.inquiry_type = inquiry_type.name
        }
        this.changeRoute();
    },
    setQueryData(query){
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {
        inquiry_type: query.inquiry_type,
        answer_complete: query.answer_complete,
        per_page: query.per_page
      }
      this.sortable = {
        order:  query.sort,
        sort: query.sort_order
      }
    },
    resetAll(){
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }
      this.filter = {
        inquiry_type: 'all',
        answer_complete: 'all',
        per_page: 20
      }
      this.filter2 = {
        inquiry_type: this.$t('common.all'),
        answer_complete: this.$t('common.all'),
        per_page: 20
      }

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'parent.email,parent.name,student.student_id,student.name,inquiry_type.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 20
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery(){
        this.changeRoute();
    },
    sorting({column, order}) {
        this.queryParams.sort = column;
        this.queryParams.sort_order = order;
        this.queryParams.page = 1;
        this.changeRoute()
    },
    pageChanged(page) {
        this.queryParams.page = page;
        this.changeRoute()
    },
    changePerPageFilter(per_page){
      this.filter.per_page = per_page
      this.changeRoute();
    },
    changeStatusFilter(answer_complete){
      this.filter.answer_complete = answer_complete
      this.filter2.answer_complete = this.$t(answer_complete)
      this.changeRoute();
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.axios.get('/consultations', {
            params: {...this.queryParams, ...this.filter}
        }).then((response) => {
            this.consultations = response.data.data;
            this.pagination = response.data.meta;
        })
    },
    openConsultationRequestModal(row){
      this.consultationData = row
      this.showConsultationRequestModal = true;
    },
    closeModal(){
      this.consultationData = ''
      this.showConsultationRequestModal = false;
      this.loadData();
    },
    deleteRecord(row) {
      this.$swal({
        title: this.$t('common.deleteConfirmation'),
        text: this.$t('common.warning'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('common.yesDelete'),
        cancelButtonText: this.$t('common.noCancel'),
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/consultations/'+row.id).then(() => {
            this.loadData();
            this.$swal.fire(
              this.$t('common.deleted'),
              this.$t('common.deleteMessage'),
              'success'
            )
          });
        }
      });
    },
  }
}
</script>